import {Component, Input, OnInit} from '@angular/core';
import {TranslationService} from '../../services/translation.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {LocaleService} from '../../services/locale.service';

@Component({
  selector: 'app-webinar-sponsors',
  templateUrl: './webinar-sponsors.component.html',
  styleUrls: ['./webinar-sponsors.component.scss']
})
export class WebinarSponsorsComponent implements OnInit {

  @Input() webinar: any;
  environment: any = environment;
  isAop: boolean = environment.domain === 'ophthalmology';
  locale: any;

  constructor(public translationService: TranslationService, private modalService: NgbModal, private localeService: LocaleService) {
    this.locale = this.localeService.currentLocale();
  }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content);
  }

}



